import { useContext } from 'react'

import { VideoContext } from '../../../../components/ReusableComponents/VideoTutorial/index'
import { ReactComponent as CloseIcon } from './close.svg'
import styles from './Instructions.module.scss'
import operaLogo from './opera.png'

const Cta = ({ children, secondary, disabled, ...props }) => (
  <button
    disabled={disabled ? true : false}
    className={secondary ? styles.secondaryCta : styles.cta}
    {...props}
  >
    {children}
  </button>
)

const Wrapper = ({ children }) => (
  <div className={styles.wrapper}>
    <div className={styles.header}>
      <img
        src={operaLogo}
        className={styles.operaLogo}
        alt="opera logo"
        onDoubleClick={() => window.open('Templates.zip')}
      />
      <a href="/analytics">
        <CloseIcon />
      </a>
    </div>
    <div className={styles.step}>{children}</div>
  </div>
)

// step 1

const InstructionA0 = () => {
  const { play, isReady } = useContext(VideoContext)

  return (
    <Wrapper title="Opera PMS sync tutorial">
      <p>This tutorial will show you how to set up PMS sync with Directful</p>
      <Cta disabled={!isReady} onClick={play}>
        Start tutorial
      </Cta>
    </Wrapper>
  )
}

const StepA1 = () => {
  return (
    <Wrapper title="Opening reports">
      <ul>
        <li>
          Go to <strong>Setup > Configuration</strong>
        </li>
        <li>
          Then <strong>Setup > Reports Setup > Reports</strong>
        </li>
      </ul>
    </Wrapper>
  )
}

const TestA1 = () => {
  const { play, goToAndPlay } = useContext(VideoContext)

  return (
    <Wrapper title="Opening reports">
      <p>Did reports window open?</p>
      <br />
      <Cta onClick={play}>Yes</Cta>
      <Cta secondary onClick={() => goToAndPlay(0)}>
        No, show me again
      </Cta>
    </Wrapper>
  )
}

const StepA2 = () => {
  return (
    <Wrapper title="Opening new report window">
      <ul>
        <li>
          Select <strong>Reseration</strong> from report group
        </li>
        <li>
          Then click <strong>New</strong>
        </li>
      </ul>
    </Wrapper>
  )
}

const TestA2 = () => {
  const { play, goToAndPlay } = useContext(VideoContext)

  return (
    <Wrapper title="Opening reports">
      <p>Did new report screen open?</p>
      <br />
      <Cta onClick={play}>Yes</Cta>
      <Cta secondary onClick={() => goToAndPlay(9.5)}>
        No, show me again
      </Cta>
    </Wrapper>
  )
}

const StepA3 = () => {
  const { goToAndPlay } = useContext(VideoContext)

  return (
    <Wrapper goToAndPlay={goToAndPlay} title="Creating report by booking date">
      <p>Fill the form with these values:</p>
      <br />
      <p>
        <strong>Report name</strong>
        <br />
        Invite guests by booking date
      </p>
      <br />
      <p>
        <strong>Simple report</strong>
        <br />
        Checked
      </p>
      <br />
      <p>
        <strong>Destiantion</strong>
        <br />
        Email
      </p>
    </Wrapper>
  )
}

const TestA3 = () => {
  const { play, goToAndPlay } = useContext(VideoContext)

  return (
    <Wrapper goToAndPlay={goToAndPlay} title="Creating report by booking date">
      <p>Does your form have these values?</p>
      <br />
      <p>
        <strong>Report name</strong>
        <br />
        Invite guests by booking date
      </p>
      <br />
      <p>
        <strong>Simple report</strong>
        <br />
        Checked
      </p>
      <br />
      <p>
        <strong>Destiantion</strong>
        <br />
        Email
      </p>
      <br />
      <Cta onClick={play}>Yes</Cta>
      <Cta secondary onClick={() => goToAndPlay(19.5)}>
        No, show me again
      </Cta>
    </Wrapper>
  )
}

const StepA4 = () => {
  const { goToAndPlay } = useContext(VideoContext)

  return (
    <Wrapper goToAndPlay={goToAndPlay}>
      <p>
        Click on <strong>Customize</strong>
      </p>
      <p>Download the template</p>
      <p>
        <a download href="/guestbookingdetailsbybookingdate1788811.osr">
          <Cta>Download template</Cta>
        </a>
      </p>
      <br />
      <p>Then click on import and select the template file you just downloaded.</p>
      <br />
      <p>Click OK and OK </p>
    </Wrapper>
  )
}

const TestA4 = () => {
  const { play, goToAndPlay } = useContext(VideoContext)

  return (
    <Wrapper goToAndPlay={goToAndPlay}>
      <p>Did you upload the inviteGuestByReservationDate file?</p>
      <p>Are you on reports screen again?</p>
      <Cta onClick={play}>Yes to all</Cta>
      <Cta secondary onClick={() => goToAndPlay(33.5)}>
        No, show me again
      </Cta>
    </Wrapper>
  )
}

const StepA5 = () => {
  const { goToAndPlay } = useContext(VideoContext)

  return (
    <Wrapper goToAndPlay={goToAndPlay}>
      <p>
        Click <strong>New</strong> and fill the form with these values:
      </p>
      <br />
      <p>
        <strong>Report name</strong>
        <br />
        Invite guests by checkout
      </p>
      <p>
        <strong>Simple report</strong>
        <br />
        Checked
      </p>
      <p>
        <strong>Destiantion</strong>
        <br />
        Email
      </p>
    </Wrapper>
  )
}

const TestA5 = () => {
  const { play, goToAndPlay } = useContext(VideoContext)

  return (
    <Wrapper goToAndPlay={goToAndPlay}>
      <p>Does your form have these values?</p>
      <br />
      <p>
        <strong>Report name</strong>
        <br />
        Invite guests by checkout
      </p>
      <p>
        <strong>Simple report</strong>
        <br />
        Checked
      </p>
      <p>
        <strong>Destiantion</strong>
        <br />
        Email
      </p>
      <br />
      <Cta onClick={play}>Yes</Cta>
      <Cta secondary onClick={() => goToAndPlay(54.5)}>
        No, show me again
      </Cta>
    </Wrapper>
  )
}

const StepA6 = () => {
  const { goToAndPlay } = useContext(VideoContext)

  return (
    <Wrapper goToAndPlay={goToAndPlay}>
      <p>
        Click on <strong>Customize</strong>
      </p>
      <p>Download the template</p>
      <p>
        <a download href="/guestbookingdetailsbyactualcheckout1790311.osr">
          <Cta>Download template</Cta>
        </a>
      </p>
      <br />
      <p>Then click on import and select the template file you just downloaded.</p>
      <p>Click OK and OK </p>
    </Wrapper>
  )
}

const TestA6 = () => {
  const { goToAndPlay, setActiveStep } = useContext(VideoContext)

  return (
    <Wrapper goToAndPlay={goToAndPlay}>
      <p>Did you upload the inviteguestsbyreservationdate file?</p>
      <p>Are you on reports screen again?</p>
      <Cta onClick={() => setActiveStep(1)}>Yes to all</Cta>
      <Cta secondary onClick={() => goToAndPlay(71.5)}>
        No, show me again
      </Cta>
    </Wrapper>
  )
}

// step 1

const InstructionB0 = () => {
  const { play, isReady } = useContext(VideoContext)

  return (
    <Wrapper>
      <p>This step will show you how to schedule the first report.</p>
      <br />
      <p>Click on button to start</p>
      <Cta disabled={!isReady} onClick={play}>
        Start tutorial
      </Cta>
    </Wrapper>
  )
}

const InstructionC0 = () => {
  const { play, isReady } = useContext(VideoContext)

  return (
    <Wrapper>
      <p>This step will show you how to schedule the second report.</p>
      <br />
      <p>Click on button to start</p>
      <Cta disabled={!isReady} onClick={play}>
        Start tutorial
      </Cta>
    </Wrapper>
  )
}

const StepB1 = () => {
  return (
    <Wrapper>
      <ul>
        <li>
          Open <strong>Miscellaneous</strong> and <strong>Reports scheduler</strong> from
          top menu
        </li>
      </ul>
    </Wrapper>
  )
}

const TestB1 = () => {
  const { play, goToAndPlay } = useContext(VideoContext)

  return (
    <Wrapper>
      <p>Did Scheduled Reports window open?</p>
      <br />
      <Cta onClick={play}>Yes</Cta>
      <Cta secondary onClick={() => goToAndPlay(0)}>
        No, show me again
      </Cta>
    </Wrapper>
  )
}

const StepB2 = () => {
  return (
    <Wrapper>
      <ul>
        <li>
          Click <strong>New</strong>
        </li>
        <li>
          Select <strong>Reservation</strong> as <strong>Report Group</strong>{' '}
        </li>
        <li>
          Select <strong>Invite guests by checkout</strong>{' '}
        </li>
        <li>
          Set file format to <strong>DELIMITED DATA</strong>
        </li>
        <li>Set delimiter to pipe ( | ) sign</li>
        <li>
          Check <strong>Fax/Email</strong> box
        </li>
        <li>Left current printer empty</li>
      </ul>
    </Wrapper>
  )
}

const TestB2 = () => {
  const { play, goToAndPlay } = useContext(VideoContext)

  return (
    <Wrapper>
      <p>Do you have the following values?</p>
      <br />
      <p>
        Report group is <strong>Reservation</strong>
      </p>
      <p>
        <strong>Invite guests by checkout</strong> is selected
      </p>
      <p>
        File format is <strong>DELIMITED DATA</strong>
      </p>
      <p>
        Delimiter is <strong>|</strong>
      </p>
      <p>Fax/Email is checked</p>
      <Cta onClick={play}>Yes</Cta>
      <Cta secondary onClick={() => goToAndPlay(11.5)}>
        No, show me again
      </Cta>
    </Wrapper>
  )
}

const StepB3 = () => {
  return (
    <Wrapper>
      <ul>
        <li>
          Click <strong>OK</strong>
        </li>
        <li>Change date to todays date</li>
        <li>Change time to some time later today</li>
        <li>
          For repeat, select <strong>1</strong> and <strong>Days</strong>
        </li>
      </ul>
    </Wrapper>
  )
}

const TestB3 = () => {
  const { play, goToAndPlay } = useContext(VideoContext)

  return (
    <Wrapper>
      <p>Is start date on today's date?</p>
      <p>
        Is repeat part showing <strong>Every 1 days</strong>?
      </p>
      <Cta onClick={play}>Yes to all</Cta>
      <Cta secondary onClick={() => goToAndPlay(37.5)}>
        No, show me again
      </Cta>
    </Wrapper>
  )
}

const StepB4 = ({ subsidiaryShortLinkToken }) => {
  return (
    <Wrapper>
      <ul>
        <li>
          Click <strong>OK</strong>
        </li>
        <li>
          Enter <strong>Auto Invite</strong> for name
        </li>
        <li>
          Enter <strong>{subsidiaryShortLinkToken}@in.autoinvite.io</strong> to To Email
        </li>
      </ul>
    </Wrapper>
  )
}

const TestB4 = ({ subsidiaryShortLinkToken }) => {
  const { play, goToAndPlay } = useContext(VideoContext)

  return (
    <Wrapper>
      <p>
        Is the name <strong>Auto Invite</strong> and email is{' '}
        <strong>{subsidiaryShortLinkToken}@in.autoinvite.io</strong>?
      </p>
      <Cta onClick={play}>Yes</Cta>
      <Cta secondary onClick={() => goToAndPlay(47.5)}>
        No, show me again
      </Cta>
    </Wrapper>
  )
}

const StepB5 = () => {
  return (
    <Wrapper>
      <ul>
        <li>
          Click <strong>OK</strong>
        </li>
        <li>
          Click <strong>File</strong>
        </li>
        <li>
          Click <strong>Close</strong> on next screen
        </li>
      </ul>
    </Wrapper>
  )
}

const TestB5 = () => {
  const { play, goToAndPlay } = useContext(VideoContext)

  return (
    <Wrapper>
      <p>
        Are you back on <strong>Scheduled Reports</strong>?
      </p>
      <Cta onClick={play}>Yes</Cta>
      <Cta secondary onClick={() => goToAndPlay(60.5)}>
        No, show me again
      </Cta>
    </Wrapper>
  )
}

const StepB6 = () => {
  return (
    <Wrapper>
      <ul>
        <li>
          Click <strong>parameters</strong>
        </li>
        <li>
          Click on <strong>Set Date</strong>
        </li>
        <li>
          Click on <strong>+/-</strong> once
        </li>
        <li>Make sure it's -1 day</li>
      </ul>
    </Wrapper>
  )
}

const TestB6 = () => {
  const { play, goToAndPlay } = useContext(VideoContext)

  return (
    <Wrapper>
      <p>Please check the dates on the bottom.</p>
      <br />
      <p>Is date on the right one day before from left one?</p>
      <Cta onClick={play}>Yes</Cta>
      <Cta secondary onClick={() => goToAndPlay(75.5)}>
        No, show me again
      </Cta>
    </Wrapper>
  )
}

const StepB7 = () => {
  return (
    <Wrapper>
      <ul>
        <li>
          Click <strong>OK</strong>
        </li>
        <li>
          Select <strong>To actual deperture date</strong>
        </li>
        <li>
          Click <strong>Set Date</strong>
        </li>
        <li>
          This time click <strong>OK</strong> with no changes
        </li>
      </ul>
    </Wrapper>
  )
}

const TestB7 = () => {
  const { play, goToAndPlay } = useContext(VideoContext)

  return (
    <Wrapper>
      <p>On the bottom of Scheduled Reports screen are you seeing this?</p> <br />
      <p>From actual departure date</p>
      <p>
        <strong>REPORT DATE - 1 DAYS</strong>
      </p>
      <br />
      <p>To actual departure date</p>
      <p>
        <strong>REPORT DATE</strong>
      </p>
      <br />
      <Cta onClick={play}>Yes</Cta>
      <Cta secondary onClick={() => goToAndPlay(95.5)}>
        No, show me again
      </Cta>
    </Wrapper>
  )
}

const StepC1 = () => {
  return (
    <Wrapper>
      <ul>
        <li>
          Click <strong>New</strong>
        </li>
        <li>
          Select <strong>Reservation</strong> as <strong>Report Group</strong>{' '}
        </li>
        <li>
          Select <strong>Invite guests by booking date</strong>{' '}
        </li>
        <li>
          Set file format to <strong>DELIMITED DATA</strong>
        </li>
        <li>Set delimiter to pipe ( | ) sign</li>
        <li>
          Check <strong>Fax/Email</strong> box
        </li>
        <li>Left current printer empty</li>
      </ul>
    </Wrapper>
  )
}

const TestC1 = () => {
  const { play, goToAndPlay } = useContext(VideoContext)

  return (
    <Wrapper>
      <p>Do you have the following values?</p>
      <br />
      <p>
        Report group is <strong>Reservation</strong>
      </p>
      <p>
        <strong>Invite guests by booking date</strong> is selected
      </p>
      <p>
        File format is <strong>DELIMITED DATA</strong>
      </p>
      <p>
        Delimiter is <strong>|</strong>
      </p>
      <p>Fax/Email is checked</p>
      <Cta onClick={play}>Yes</Cta>
      <Cta secondary onClick={() => goToAndPlay(0.5)}>
        No, show me again
      </Cta>
    </Wrapper>
  )
}

const StepC2 = () => {
  return (
    <Wrapper>
      <ul>
        <li>
          Click <strong>OK</strong>
        </li>
        <li>Change date to todays date</li>
        <li>Change time to some time later today</li>
        <li>
          For repeat, select <strong>1</strong> and <strong>Hours</strong>
        </li>
      </ul>
    </Wrapper>
  )
}

const TestC2 = () => {
  const { play, goToAndPlay } = useContext(VideoContext)

  return (
    <Wrapper>
      <p>Is start date on today's date?</p>
      <p>
        Is repeat part showing <strong>Every 1 hours</strong>?
      </p>
      <Cta onClick={play}>Yes to all</Cta>
      <Cta secondary onClick={() => goToAndPlay(21.5)}>
        No, show me again
      </Cta>
    </Wrapper>
  )
}

const StepC3 = ({ subsidiaryShortLinkToken }) => {
  return (
    <Wrapper>
      <ul>
        <li>
          Click <strong>OK</strong>
        </li>
        <li>
          Enter <strong>Auto Invite</strong> for name
        </li>
        <li>
          Enter <strong>{subsidiaryShortLinkToken}@in.autoinvite.io</strong> to To Email
        </li>
      </ul>
    </Wrapper>
  )
}

const TestC3 = ({ subsidiaryShortLinkToken }) => {
  const { play, goToAndPlay } = useContext(VideoContext)

  return (
    <Wrapper>
      <p>
        Is the name <strong>Auto Invite</strong> and email is{' '}
        <strong>{subsidiaryShortLinkToken}@in.autoinvite.io</strong>?
      </p>
      <Cta onClick={play}>Yes</Cta>
      <Cta secondary onClick={() => goToAndPlay(30.5)}>
        No, show me again
      </Cta>
    </Wrapper>
  )
}

const StepC4 = () => {
  return (
    <Wrapper>
      <ul>
        <li>
          Click <strong>OK</strong>
        </li>
        <li>
          Click <strong>File</strong>
        </li>
        <li>
          Click <strong>Close</strong> on next screen
        </li>
      </ul>
    </Wrapper>
  )
}

const TestC4 = () => {
  const { play, goToAndPlay } = useContext(VideoContext)

  return (
    <Wrapper>
      <p>
        Are you back on <strong>Scheduled Reports</strong>?
      </p>
      <Cta onClick={play}>Yes</Cta>
      <Cta secondary onClick={() => goToAndPlay(39.5)}>
        No, show me again
      </Cta>
    </Wrapper>
  )
}

const StepC5 = () => {
  return (
    <Wrapper>
      <ul>
        <li>
          Select <strong>Invite guests by booking date</strong>
        </li>
        <li>Make sure parameters is selected</li>
        <li>
          Select <strong>From Creation Date</strong>
        </li>
        <li>
          Click on <strong>Set Date</strong>
        </li>
        <li>Just click OK on next screen</li>
      </ul>
    </Wrapper>
  )
}

const TestC5 = () => {
  const { play, goToAndPlay } = useContext(VideoContext)

  return (
    <Wrapper>
      <p>
        Does <strong>From Creation Date</strong> correspond to{' '}
        <strong>REPORT DATE</strong> now?
      </p>
      <br />
      <Cta onClick={play}>Yes</Cta>
      <Cta secondary onClick={() => goToAndPlay(51.5)}>
        No, show me again
      </Cta>
    </Wrapper>
  )
}

const StepC6 = () => {
  return (
    <Wrapper>
      <ul>
        <li>
          Select <strong>To Creation Date</strong>
        </li>
        <li>
          Click on <strong>Set Date</strong>
        </li>
        <li>
          Click on <strong>+/-</strong> twice to set the date{' '}
          <strong>REPORT DATE + DAYS</strong>
        </li>
        <li>
          Click <strong>OK</strong>
        </li>
      </ul>
    </Wrapper>
  )
}

const TestC6 = () => {
  const { play, goToAndPlay } = useContext(VideoContext)

  return (
    <Wrapper>
      <p>
        Does <strong>To Creation Date</strong> correspond to{' '}
        <strong>REPORT DATE+1 DAYS</strong> now?
      </p>
      <Cta onClick={play}>Yes</Cta>
      <Cta secondary onClick={() => goToAndPlay(69.5)}>
        No, show me again
      </Cta>
    </Wrapper>
  )
}

const StepC7 = () => {
  return (
    <Wrapper>
      <ul>
        <li>
          Select <strong>From Cancellation Date</strong>
        </li>
        <li>
          Click on <strong>Set Date</strong>
        </li>
        <li>
          Just click <strong>OK</strong>
        </li>
      </ul>
    </Wrapper>
  )
}

const TestC7 = () => {
  const { play, goToAndPlay } = useContext(VideoContext)

  return (
    <Wrapper>
      <p>
        Does <strong>From Cancellation Date</strong> correspond to{' '}
        <strong>REPORT DATE</strong>?
      </p>
      <Cta onClick={play}>Yes</Cta>
      <Cta secondary onClick={() => goToAndPlay(80)}>
        No, show me again
      </Cta>
    </Wrapper>
  )
}

const StepC8 = () => {
  return (
    <Wrapper>
      <ul>
        <li>
          Select <strong>To Cancellation Date</strong>
        </li>
        <li>
          Click on <strong>Set Date</strong>
        </li>
        <li>
          Click on <strong>+/-</strong> twice to set the date{' '}
          <strong>REPORT DATE + DAYS</strong>
        </li>
        <li>
          Click <strong>OK</strong>
        </li>
      </ul>
    </Wrapper>
  )
}

const TestC8 = () => {
  const { play, goToAndPlay } = useContext(VideoContext)

  return (
    <Wrapper>
      <p>
        Does <strong>To Cancellation Date</strong> correspond to{' '}
        <strong>REPORT DATE+1 DAYS</strong> now?
      </p>
      <Cta onClick={play}>Yes</Cta>
      <Cta secondary onClick={() => goToAndPlay(87)}>
        No, show me again
      </Cta>
    </Wrapper>
  )
}

const StepC9 = () => {
  return (
    <Wrapper>
      <p>That's all!</p>
      <br />
      <p>
        You can do a qucik test by clicking <strong>Run Now</strong>{' '}
      </p>
      <br />
      <p>If no errors are showing up it means PMS sync is complete.</p>
    </Wrapper>
  )
}

const TestC9 = () => {
  return (
    <Wrapper>
      <p>You succesfully completed PMS sync for Opera.</p>
      <br />
      <a href="https://dashboard.swaypay.io/analytics">
        <Cta>Go back to dashboard</Cta>
      </a>
      <p></p>
    </Wrapper>
  )
}

export function generateOperaVideoSteps(subsidiaryShortLinkToken) {
  return [
    {
      name: '1. Creating Reports',
      youtubeId: 'zcZ1f8k4sbo',
      breakpoints: [
        {
          name: 'Introduction',
          start: 0,
          message: <InstructionA0 />
        },
        {
          name: 'Opening reports',
          start: 0.5,
          end: 9,
          message: <StepA1 />,
          instruction: <TestA1 />
        },
        {
          name: 'Opening new report',
          start: 9.5,
          end: 19,
          message: <StepA2 />,
          instruction: <TestA2 />
        },
        {
          name: 'Creating report by booking date',
          start: 19.5,
          end: 33,
          message: <StepA3 />,
          instruction: <TestA3 />
        },
        {
          name: 'Importing "by booking date" template',
          start: 33.5,
          end: 54,
          message: <StepA4 />,
          instruction: <TestA4 />
        },
        {
          name: 'Creating second report by checkout',
          start: 54.5,
          end: 71,
          message: <StepA5 />,
          instruction: <TestA5 />
        },
        {
          name: 'Importing "by checkout" template',
          start: 71.5,
          end: 91,
          message: <StepA6 />,
          instruction: <TestA6 />
        }
      ]
    },
    {
      name: '2. Scheduling by checkout report',
      youtubeId: 'Yu97xkd9CjE',
      breakpoints: [
        {
          start: 0,
          message: <InstructionB0 />
        },
        {
          name: 'Opening Scheduled Reports',
          start: 0.5,
          end: 8,
          message: <StepB1 />,
          instruction: <TestB1 />
        },
        {
          name: 'Scheduling by checkout',
          start: 8.5,
          end: 37,
          message: <StepB2 />,
          instruction: <TestB2 />
        },
        {
          name: 'Setting report times',
          start: 37.5,
          end: 47,
          message: <StepB3 />,
          instruction: <TestB3 />
        },
        {
          name: 'Setting up sending report',
          start: 47.5,
          end: 60,
          message: <StepB4 subsidiaryShortLinkToken={subsidiaryShortLinkToken} />,
          instruction: <TestB4 subsidiaryShortLinkToken={subsidiaryShortLinkToken} />
        },
        {
          name: 'Going back to Scheduled Reports',
          start: 60.5,
          end: 76,
          message: <StepB5 />,
          instruction: <TestB5 />
        },
        {
          name: 'Setting parameters 1',
          start: 76.5,
          end: 95,
          message: <StepB6 />,
          instruction: <TestB6 />
        },
        {
          name: 'Setting parameters 2',
          start: 95.5,
          end: 107,
          message: <StepB7 />,
          instruction: <TestB7 />
        }
      ]
    },
    {
      name: '3. Scheduling by booking report',
      youtubeId: '6epw5SP6_cc',
      breakpoints: [
        {
          start: 0,
          message: <InstructionC0 />
        },
        {
          name: 'Scheduling by booking',
          start: 0.5,
          end: 21,
          message: <StepC1 />,
          instruction: <TestC1 />
        },
        {
          name: 'Setting report times',
          start: 21.5,
          end: 30,
          message: <StepC2 />,
          instruction: <TestC2 />
        },
        {
          name: 'Setting up sending report',
          start: 30.5,
          end: 39,
          message: <StepC3 subsidiaryShortLinkToken={subsidiaryShortLinkToken} />,
          instruction: <TestC3 subsidiaryShortLinkToken={subsidiaryShortLinkToken} />
        },
        {
          name: 'Going back to Scheduled Reports',
          start: 39.5,
          end: 51,
          message: <StepC4 />,
          instruction: <TestC4 />
        },
        {
          name: 'Setting parameters 1',
          start: 51.5,
          end: 69,
          message: <StepC5 />,
          instruction: <TestC5 />
        },
        {
          name: 'Setting parameters 2',
          start: 69.5,
          end: 80,
          message: <StepC6 />,
          instruction: <TestC6 />
        },
        {
          name: 'Setting parameters 3',
          start: 80,
          end: 87,
          message: <StepC7 />,
          instruction: <TestC7 />
        },
        {
          name: 'Setting parameters 4',
          start: 87,
          end: 97,
          message: <StepC8 />,
          instruction: <TestC8 />
        },
        {
          name: 'Testing',
          start: 97,
          end: 105,
          message: <StepC9 />,
          instruction: <TestC9 />
        }
      ]
    }
  ]
}
